import * as React from "react";
const SvgLoadingFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17 7a5 5 0 0 1 0 10H7A5 5 0 0 1 7 7zm-5 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m6 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-12 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3", clipRule: "evenodd" }));
export default SvgLoadingFill;
